import {ApolloError} from "@apollo/client";

/**
 * Liefert die vom Server gemeldete Fehlermeldung — oder den übergebenen
 * generischen Fallback-Text, wenn keine verwertbare Meldung vorliegt.
 *
 * Hintergrund: Mehrere Server-Guards transportieren die handlungsleitende
 * Erklärung ausschließlich in der GraphQL-Message (z.B.
 * `MOLLIE_WAITLIST_PAID_CANNOT_DELETE`: „Für diesen Wartelistenplatz ist eine
 * Online-Zahlung eingegangen. Bitte erstatten Sie die Zahlung …"). Fängt der
 * Client den Fehler ab und ersetzt ihn durch einen generischen Text, verliert
 * die Nutzerin genau die Information, die ihr sagt, was zu tun ist.
 *
 * Bewusst OHNE Code-basierte Fallunterscheidung: reines Durchreichen, damit
 * neue Server-Guards ohne Client-Änderung sichtbar werden. Das ist dasselbe
 * Muster, das die Buchungsliste über `useDeleteMessage` bereits nutzt
 * (`errorMessage: deleteBookingError?.message`).
 *
 * `graphQLErrors[0].message` hat Vorrang vor `ApolloError.message`: Letztere
 * ist bei mehreren Fehlern eine zusammengesetzte Zeichenkette, erstere die
 * exakte Guard-Meldung.
 *
 * Node 14 / TypeScript 4.7 kompatibel.
 *
 * @param error    Der gefangene Fehler (unknown — Catch-Blöcke sind untypisiert).
 * @param fallback Generischer Text, wenn der Fehler keine Meldung trägt.
 */
export const resolveServerErrorMessage = (error: unknown, fallback: string): string => {
    if (error instanceof ApolloError) {
        const graphQLMessage = error.graphQLErrors?.[0]?.message;

        if (graphQLMessage) {
            return graphQLMessage;
        }
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return fallback;
};

export default resolveServerErrorMessage;
